import React from 'react';
import { CalendarIcon, SmartphoneIcon, MonitorIcon, FilterIcon, ExternalLinkIcon, ClockIcon, UserIcon, FileTextIcon, RefreshCwIcon } from 'lucide-react';
interface TopBarProps {
  dateRange: string;
  setDateRange: (range: string) => void;
  device: string;
  setDevice: (device: string) => void;
  scenario: string;
  setScenario: (scenario: string) => void;
  priceDisplay: string;
  setPriceDisplay: (display: string) => void;
}
export const TopBar: React.FC<TopBarProps> = ({
  dateRange,
  setDateRange,
  device,
  setDevice,
  scenario,
  setScenario,
  priceDisplay,
  setPriceDisplay
}) => {
  return <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm" data-id="element-375">
      <div className="container mx-auto px-4 py-3 max-w-7xl" data-id="element-376">
        <div className="flex flex-col gap-3" data-id="element-377">
          {/* Title */}
          <div className="flex items-center justify-between" data-id="element-378">
            <h1 className="text-xl font-semibold text-gray-800 truncate" data-id="element-379">
              Tilbuds-aktivitet & opfølgning
            </h1>
            <span className="text-sm text-gray-500 flex items-center gap-1 whitespace-nowrap ml-2" data-id="element-380">
              <RefreshCwIcon size={14} data-id="element-381" /> Sidst synkroniseret: 10:42
            </span>
          </div>
          {/* Info chips */}
          <div className="flex flex-wrap gap-2 text-sm" data-id="element-382">
            <div className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-1" data-id="element-383">
              <UserIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-384" />
              <span className="truncate" data-id="element-385">Anders Nielsen</span>
            </div>
            <div className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-1" data-id="element-386">
              <FileTextIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-387" />
              <span className="truncate" data-id="element-388">Quote-ID: Q-2023-4587</span>
            </div>
            <div className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-1" data-id="element-389">
              <ExternalLinkIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-390" />
              <span className="text-red-600 truncate" data-id="element-391">Åbn tilbud</span>
            </div>
            <div className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-1" data-id="element-392">
              <ClockIcon size={14} className="text-gray-500 flex-shrink-0" data-id="element-393" />
              <span className="truncate" data-id="element-394">Gyldig til: 15. juni 2023</span>
            </div>
          </div>
          {/* Filters */}
          <div className="flex flex-wrap gap-3 py-1 text-sm" data-id="element-395">
            <div className="flex items-center gap-1" data-id="element-396">
              <CalendarIcon size={16} className="text-gray-500 flex-shrink-0" data-id="element-397" />
              <select className="bg-white border border-gray-300 rounded-md px-2 py-1" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-398">
                <option data-id="element-399">7 dage</option>
                <option data-id="element-400">14 dage</option>
                <option data-id="element-401">30 dage</option>
                <option data-id="element-402">Alle</option>
              </select>
            </div>
            <div className="flex items-center gap-1" data-id="element-403">
              <div className="flex items-center border border-gray-300 rounded-md overflow-hidden" data-id="element-404">
                <button className={`px-2 py-1 flex items-center gap-1 ${device === 'Alle' || device === 'Mobil' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setDevice('Mobil')} data-id="element-405">
                  <SmartphoneIcon size={16} className="text-gray-500 flex-shrink-0" data-id="element-406" />
                  <span className="whitespace-nowrap" data-id="element-407">Mobil</span>
                </button>
                <button className={`px-2 py-1 flex items-center gap-1 ${device === 'Alle' || device === 'Desktop' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setDevice('Desktop')} data-id="element-408">
                  <MonitorIcon size={16} className="text-gray-500 flex-shrink-0" data-id="element-409" />
                  <span className="whitespace-nowrap" data-id="element-410">Desktop</span>
                </button>
              </div>
            </div>
            <div className="flex items-center gap-1" data-id="element-411">
              <FilterIcon size={16} className="text-gray-500 flex-shrink-0" data-id="element-412" />
              <select className="bg-white border border-gray-300 rounded-md px-2 py-1" value={scenario} onChange={e => setScenario(e.target.value)} data-id="element-413">
                <option data-id="element-414">Alle</option>
                <option data-id="element-415">Good</option>
                <option data-id="element-416">Better</option>
                <option data-id="element-417">Best</option>
              </select>
            </div>
            <div className="flex items-center gap-1" data-id="element-418">
              <select className="bg-white border border-gray-300 rounded-md px-2 py-1" value={priceDisplay} onChange={e => setPriceDisplay(e.target.value)} data-id="element-419">
                <option data-id="element-420">Med moms</option>
                <option data-id="element-421">Uden moms</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>;
};